import React, { useState } from "react";
import StackedBarChart from "../Graphs/CompanyDocs/StackedBarChart";
import DoughnutComp from "../Graphs/CompanyDocs/Doughnut";
import NoResultsBox from "../Common/NoResultsBox/NoResultsBox";
import { getKeys } from "../../utils/CompanyDocs";
import "./CompanyDocSummary.scss";

const CompanyDocSummary = ({ summary, insights }) => {
  const labels =
    summary?.length > 0 ? getKeys([...summary], "DoughnutComp") : [];
  const lastQuarter = labels?.length > 0 ? labels[0] : "";

  const [activePanel, setActivePanel] = useState("left");

  const handleCardClick = (panel) => {
    setActivePanel((prev) => (prev === panel ? null : panel));
  };

  return (
    <>
      {summary?.length > 0 ? (
        <div className="cds-container">
          {/* Header */}
          <div className="cds-header">
            <div className="cds-header-left">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a2f4e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" /></svg>
              <h6 className="cds-title">Key Insights</h6>
            </div>
            <div className="cds-tabs">
              <button
                className={`cds-tab ${activePanel === "left" ? "cds-tab--active" : ""}`}
                onClick={() => handleCardClick("left")}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /></svg>
                Last 4 Quarters
              </button>
              <button
                className={`cds-tab ${activePanel === "right" ? "cds-tab--active" : ""}`}
                onClick={() => handleCardClick("right")}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.21 15.89A10 10 0 1 1 8 2.83" /><path d="M22 12A10 10 0 0 0 12 2v10z" /></svg>
                {lastQuarter ? `${lastQuarter} Summary` : "Quarter Summary"}
              </button>
            </div>
          </div>

          {/* Content */}
          <div className={`cds-content ${activePanel ? "cds-content--split" : ""}`}>
            {/* Insights list */}
            <div className="cds-insights">
              {insights?.Insights?.length > 0 ? (
                <ul className="cds-insights-list">
                  {insights.Insights.map((insight, index) => (
                    <li key={index}>
                      <span className="cds-insight-bullet" />
                      <span>{insight}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="cds-no-data">No insights available</p>
              )}
            </div>

            {/* Chart */}
            {activePanel && (
              <div className="cds-chart-card">
                <div className="cds-chart-label">
                  {activePanel === "left" ? "Shareholding Pattern" : `${lastQuarter} Breakdown`}
                </div>
                <div className="cds-chart-body">
                  {activePanel === "left" ? (
                    <StackedBarChart data={summary} />
                  ) : (
                    <DoughnutComp data={summary} lastQuarter={lastQuarter} />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="cds-empty">
          <NoResultsBox showEmptyImage={true} displayText="No Summary Data" />
        </div>
      )}
    </>
  );
};

export default CompanyDocSummary;
